import React from 'react';
import { formatHhMm, formatPercent } from '../../utils/format';
import type { FloorStates } from '../../types/voip';
interface FloorTotalsProps {
  totals: FloorStates;
  agentDays: number;
  hasData: boolean;
  perDay: boolean;
}
export function FloorTotals({
  totals,
  agentDays,
  hasData,
  perDay
}: FloorTotalsProps) {
  const logged = totals.loggedIn || 1;
  const avg = (v: number) => agentDays === 0 ? 0 : v / agentDays;
  const avgLabel = perDay ? 'avg per agent/day' : 'avg per agent';
  const cards = [{
    key: 'onCall',
    label: 'On Call',
    note: 'Talk time',
    value: totals.onCall,
    swatch: 'bg-accent'
  }, {
    key: 'waiting',
    label: 'Waiting',
    note: 'Ready but idle',
    value: totals.waiting,
    swatch: 'bg-bright/30'
  }, {
    key: 'ready',
    label: 'Ready',
    note: 'All Ready time, incl. Waiting',
    value: totals.ready,
    swatch: 'bg-bright'
  }, {
    key: 'notReady',
    label: 'Not Ready',
    note: 'Incl. after-call work',
    value: totals.notReady,
    swatch: 'bg-silver/45'
  }];
  return <section aria-label="Team floor time totals" className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4" data-id="element-222" data-mp="1sl3tkg22rshk">
      {cards.map((c, i) => {
      const primary = i === 0;
      return <div key={c.key} className={`flex flex-col rounded-2xl border p-5 shadow-card ${primary ? 'border-accent bg-accent text-on-accent' : 'border-line bg-surface'}`} data-id="element-223" data-mp="1jsa27k9ct2nc" data-mpi={i}>
            <p className={`flex items-center gap-2 text-sm font-semibold ${primary ? 'text-on-accent' : 'text-ink'}`} data-id="element-224" data-mp="2bj6fun38nbbo">
              <span className={`h-2.5 w-2.5 rounded-sm ${primary ? 'bg-on-accent' : c.swatch}`} aria-hidden data-id="element-225" data-mp="27hl10w758myu" />
              {c.label}
              <span className={`text-xs font-normal ${primary ? 'text-on-accent/75' : 'text-subtle'}`} data-id="element-226" data-mp="22gx4jv05bdx8">{c.note}</span>
            </p>
            <p className={`mt-3 font-display text-[34px] font-bold leading-none tabular-nums tracking-tight ${primary ? 'text-on-accent' : 'text-ink'}`} data-id="element-227" data-mp="r3l47u3lhdft">
              {hasData ? formatHhMm(c.value) : '--:--'}
            </p>
            <p className={`mt-1 text-xs ${primary ? 'text-on-accent/75' : 'text-muted'}`} data-id="element-228" data-mp="nlfe6xcchswq">Team total</p>
            <div className={`mt-4 flex items-baseline justify-between gap-3 border-t pt-3 text-xs ${primary ? 'border-on-accent/20' : 'border-line'}`} data-id="element-229" data-mp="sjp8z6u5qrht">
              <span className={primary ? 'text-on-accent/85' : 'text-muted'} data-id="element-230" data-mp="enbpjs62cg0p">
                <span className={`font-semibold tabular-nums ${primary ? 'text-on-accent' : 'text-ink'}`} data-id="element-231" data-mp="ji8yz0798re4">{hasData ? formatHhMm(avg(c.value)) : '--:--'}</span> {avgLabel}
              </span>
              <span className={`font-semibold tabular-nums ${primary ? 'text-on-accent' : 'text-ink'}`} data-id="element-232" data-mp="9ngy9nidlof4">
                {hasData ? formatPercent(c.value / logged) : '—'}
                <span className={`ml-1 font-normal ${primary ? 'text-on-accent/75' : 'text-subtle'}`} data-id="element-233" data-mp="3w0p7ph265psw">of login</span>
              </span>
            </div>
          </div>;
    })}
    </section>;
}